<template>
    <span>
        <el-popover
                ref="popover5"
                placement="top"
                width="160"
                v-model="visible2">
            <p style="color:red">确定删除吗？</p>
            <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="visible2 = false">取消</el-button>
                <el-button type="primary" size="mini" @click="done">确定</el-button>
            </div>
        </el-popover>
        <el-button type="danger" size="small" class="el-button el-button--text el-button--mini"  v-popover:popover5><slot></slot></el-button>
    </span>
</template>

<script>
    export default {
        props:{
        },
        data() {
            return {
                visible2: false,
            };
        },
        methods:{
            done(){
                this.visible2 = false
                this.$emit("done")
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/DelPoperver.vue